import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';

import { StatusBadge } from '../../../components/StatusBadge/StatusBadge';
import { ItemStatusBadge } from './ItemStatusBadge';
import { formatCreatedAt, formatCurrency, parseDisplayClient,} from '../utils';

const visibilityConfig = {
  true: { label: 'Sim', variant: 'success' },
  false: { label: 'Não', variant: 'danger' },
};

export const columns = [
  {
    name: 'Cadastrado em',
    selector: (row) => row.createdAt,
    width: '180px',
    cell: (row) => (
      <div
        className="items-cell--muted"
        title={row.createdAt || 'Sem data'}
      >
        {formatCreatedAt(row.createdAt)}
      </div>
    ),
  },
  {
    name: 'Nome do produto',
    selector: (row) => row.name,
    minWidth: '200px',
    center: true,
    cell: (row) => (
      <div
        className="items-cell--truncate"
        title={row.name || '-'}
      >
        {row.name || '-'}
      </div>
    ),
  },
  {
    name: 'Código do produto',
    selector: (row) => row.code,
    minWidth: '200px',
    center: true,
    cell: (row) => (
      <div
        className="items-cell--truncate"
        title={row.code || '-'}
      >
        {row.code || '-'}
      </div>
    ),
  },
  {
    name: 'Valor',
    selector: (row) => row.value,
    width: '130px',
    cell: (row) => (
      <span className="items-cell--currency">
        {formatCurrency(row.value)}
      </span>
    ),
  },
  {
    name: 'Status',
    width: '170px',
    cell: (row) => (
      <div style={{ marginLeft: '5%' }}>
        <ItemStatusBadge item={row} />
      </div>
    ),
  },
  {
    name: 'Visível para o cliente',
    width: '200px',
    cell: (row) => {
      const displayClient =
        row.display_client !== undefined
          ? row.display_client
          : row.displayClient;

      const config =
        visibilityConfig[String(parseDisplayClient(displayClient))] ||
        visibilityConfig.false;

      return (
        <div className="d-flex justify-content-center w-100">
          <StatusBadge
            label={config.label}
            variant={config.variant}
          />
        </div>
      );
    },
  },
  {
    name: 'Opções',
    selector: (row) => row.id,
    width: '100px',
    center:true,
    cell: (row) => (
      <Dropdown className="items-row-action-dropdown">
          <Dropdown.Toggle
            bsPrefix="item-actions-toggle"
            variant="link"
            id={`items-options-${row.id}`}
            className="btn btn-light btn-icon btn-sm"
            title="Abrir opções"
            aria-label={`Abrir opções do produto ${row.name || ''}`}
          >
            <i className="ki ki-more-ver"></i>
          </Dropdown.Toggle>

          <Dropdown.Menu alignRight>
            <Dropdown.Item as={Link} to={`/payments/items/${row.id}`}>
              <i className="flaticon-eye mr-3"></i>
              Visualizar
            </Dropdown.Item>

            <Dropdown.Item as={Link} to={`/payments/items/${row.id}/edit`}>
              <i className="flaticon-edit mr-3"></i>
              Editar
            </Dropdown.Item>
          </Dropdown.Menu>
      </Dropdown>    
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  },
];